/**
 * The three non-data states every list and detail page shares. Kept as one
 * component so "could not load" and "nothing here" never get conflated: an
 * empty organization is not a failure, and a failure is not an empty list.
 */
interface StatusMessageProps {
	empty?: string;
	error?: Error | null;
	isEmpty?: boolean;
	isLoading?: boolean;
	loading?: string;
}

export const StatusMessage = ({
	empty = "Nothing here yet.",
	error,
	isEmpty,
	isLoading,
	loading = "Loading…",
}: StatusMessageProps) => {
	if (isLoading) {
		return <p className="text-secondary text-sm">{loading}</p>;
	}
	if (error) {
		return (
			<p className="text-error-primary text-sm" role="alert">
				Could not load. {error.message}
			</p>
		);
	}
	if (isEmpty) {
		return <p className="text-secondary text-sm">{empty}</p>;
	}
	return null;
};
